import GeneratingFirst from 'assets/icons/generating_1.svg?react';
import GeneratingSecond from 'assets/icons/generating_2.svg?react';
import GeneratingThird from 'assets/icons/generating_3.svg?react';
import { useEffect, useState } from 'react';

const frames = [GeneratingFirst, GeneratingSecond, GeneratingThird];

export const GeneratingIndicator = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % frames.length);
    }, 300);
    return () => clearInterval(id);
  }, []);

  const Frame = frames[index];
  return (
    <span>
      <Frame />
    </span>
  );
};
